import React from "react"

import ListItemImageShadow from "./content-loading/ListItemImageShadow"
import ContentLines from "./content-loading/ContentLines"
import ContentTags from "./content-loading/ContentTags"

export default () => (
    <div className="list-group-item">
        <ListItemImageShadow />
        <div className="list-group-item-content">
            <ContentLines />
            <ContentLines minLineLength={30} maxLineLength={70} lines={2} />
            <ContentTags tags={1} />
        </div>
    </div>
)
